var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { xl10: "", lg10: "", md12: "", xs12: "" } },
            [
              _c("PageHeader", {
                staticClass: "pb-2",
                attrs: {
                  "no-padding": "",
                  subtitle:
                    "Customize which recipients to email and which reports to send for discrete data imports.",
                },
              }),
              _vm._v(" "),
              _c("AlertsBar", { attrs: { loading: _vm.loading } }),
              _vm._v(" "),
              _c(
                "v-card",
                { staticClass: "mb-4" },
                [
                  _vm.isLoading
                    ? _c("v-progress-linear", {
                        staticClass: "position-sticky my-0",
                        attrs: { height: 5, color: "info", indeterminate: "" },
                      })
                    : _c("div", {
                        staticStyle: { width: "100%", height: "5px" },
                      }),
                  _vm._v(" "),
                  _c("Recipients", {
                    attrs: { configuration: _vm.configuration },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c("Guidelines", {
                    attrs: { configuration: _vm.configuration },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }